import styled from '@emotion/styled';

export const Cnab444GenerateModalContainer = styled.div`
  width: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const ModalSection = styled.section`
  margin-top: 28px;
  strong {
    color: ${({ theme }) => theme.palette?.brand.primary.base};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 500;
    text-underline-offset: 3px;
  }

  .disabled {
    color: ${({ theme }) => theme.palette?.brand.gray[600]};
    cursor: default;
  }

`;

export const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 48px;
`;

export const SectionContent = styled.div`
  margin-top: 16px;

  ul {
    margin-left: 20px;
  }
`;
